/**
 * 这台浏览器能不能用 WebGL2(3D 画面的底线,硬规则 12)。
 * Whether this browser can use WebGL2, the baseline for every 3D view.
 */
export function hasWebGL2(): boolean {
  try {
    return !!document.createElement("canvas").getContext("webgl2");
  } catch {
    return false;
  }
}
